import script from "./EventTicksComponentMixin.vue?vue&type=script&lang=js"
export * from "./EventTicksComponentMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__